export default __webpack_public_path__ + "static/media/airbrake.76ceca13.svg";